interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, totalPages: number): (number | string)[] {
  const pages: (number | string)[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i += 1) pages.push(i);
    return pages;
  }
  pages.push(1);
  if (current > 3) pages.push("...");
  const start = Math.max(2, current - 1);
  const end = Math.min(totalPages - 1, current + 1);
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (current < totalPages - 2) pages.push("...");
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(current, totalPages);

  const baseBtn =
    "min-w-9 h-9 px-3 flex items-center justify-center rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap";

  return (
    <nav className="flex items-center justify-center gap-1.5 flex-wrap mt-10" aria-label="分页">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${baseBtn} bg-background-900 border border-background-800 text-foreground-300 hover:border-primary-500 hover:text-accent-400 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line"></i>
        <span className="hidden sm:inline ml-1">上一页</span>
      </button>

      {pages.map((page, idx) =>
        typeof page === "number" ? (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            className={`${baseBtn} ${
              page === current
                ? "bg-primary-600 text-background-50 border border-primary-600 font-bold"
                : "bg-background-900 border border-background-800 text-foreground-300 hover:border-primary-500 hover:text-accent-400"
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={`dots-${idx}`} className="px-1 text-foreground-600">
            …
          </span>
        )
      )}

      <button
        type="button"
        disabled={current === totalPages}
        onClick={() => onChange(current + 1)}
        className={`${baseBtn} bg-background-900 border border-background-800 text-foreground-300 hover:border-primary-500 hover:text-accent-400 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <span className="hidden sm:inline mr-1">下一页</span>
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}